import { useContext, useMemo } from "react";
import { MotionContext } from "./index.js";
import { getCurrentTreeVariants } from "./utils.js";
function useCreateMotionContext(props) {
  const { initial, animate } = getCurrentTreeVariants(props, useContext(MotionContext));
  return useMemo(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
  return Array.isArray(prop) ? prop.join(" ") : prop;
}
export {
  useCreateMotionContext
};
//# sourceMappingURL=create.js.map
